import template from "./organization-region-settings.html";

const OrganizationRegionSettingsComponent = {
  template: template,
  controller: class OrganizationRegionSettingsController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $filter,
      Notification,
      OrganizationService,
      LocaleService,
      Tariff,
      SweetAlertService
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$filter = $filter;
      this.NotificationService = Notification;
      this.OrganizationService = OrganizationService;
      this.LocaleService = LocaleService;
      this.Tariff = Tariff;
      this.SweetAlertService = SweetAlertService;
    }

    $onInit() {
      this.organization = this.$rootScope.organization;
      this.editableOrganization = angular.copy(this.organization);
      this.baseUrl = process.env.CLIENT_URL;
      this.loading = false;
    }

    setAppLanguage(oldAppLanguage, newAppLanguage) {
      if (oldAppLanguage === newAppLanguage) return;

      this.selectedAppLanguage = newAppLanguage;
    }

    setTimezone(oldTimezone, newTimezone) {
      if (oldTimezone === newTimezone) return;

      this.selectedTimezone = newTimezone;
    }

    setDateFormat(oldDateFormat, newDateFormat) {
      if (oldDateFormat === newDateFormat) return;

      this.selectedDateFormat = newDateFormat;
    }

    async saveRegionSettings() {
      this.loading = true;

      if (this.selectedTimezone)
        this.editableOrganization.settings.timezone = this.selectedTimezone;
      if (this.selectedDateFormat)
        this.editableOrganization.settings.dateFormat = this.selectedDateFormat;
      if (this.selectedAppLanguage)
        this.editableOrganization.settings.appLanguage =
          this.selectedAppLanguage;

      let updateTariffs = false;

      if (this.selectedCurrency) {
        this.editableOrganization.settings.currency = this.selectedCurrency;
        updateTariffs = await this.checkTariffs();
      }

      await this.OrganizationService.updateRegionalSettings(
        this.editableOrganization,
        updateTariffs
      );

      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.updatedRegionalSettings"
        ),
      });

      if (this.selectedTimezone)
        this.LocaleService.setTimezone(this.selectedTimezone);
      if (this.selectedAppLanguage)
        this.LocaleService.setLanguage(
          this.selectedAppLanguage === "es" ? "es" : "en"
        );
      if (updateTariffs) await this.SweetAlertService.tariffPricesUpdated();

      this.editableOrganization = angular.copy(this.$rootScope.organization);

      location.reload();
    }

    async checkTariffs() {
      const tariffs = await this.Tariff.query();

      if (tariffs.length <= 0) return false;

      const action = await this.SweetAlertService.updateTariffPrices();
      if (!action) return;
      return action === "update-tariffs";
    }

    async setCurrency(oldCurrency, newCurrency) {
      this.selectedCurrency = newCurrency;
    }
  },
};

export default OrganizationRegionSettingsComponent;
